/* AUZONE theme behaviour — hero slideshow, mega menu, mobile drawer, search flyout.
   Mirrors the interaction design of the approved mockup exactly (5s? no — 6s
   autoplay hero, hover-reveal mega menus, dot navigation). */
(function () {
  'use strict';

  /* ---------------- Hero slideshow ---------------- */
  function initHero() {
    var hero = document.querySelector('[data-auzone-hero]');
    if (!hero) return;
    var slides = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-slide]'));
    var dots = Array.prototype.slice.call(hero.querySelectorAll('[data-hero-dot]'));
    if (!slides.length) return;
    var current = 0;
    var timer = null;
    var AUTOPLAY_MS = 6000;

    function show(index) {
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('opacity-100', active);
        slide.classList.toggle('scale-100', active);
        slide.classList.toggle('opacity-0', !active);
        slide.classList.toggle('scale-105', !active);
        var textBox = slide.querySelector('[data-hero-textbox]');
        if (textBox) {
          textBox.classList.toggle('opacity-100', active);
          textBox.classList.toggle('translate-y-0', active);
          textBox.classList.toggle('opacity-0', !active);
          textBox.classList.toggle('translate-y-8', !active);
        }
      });
      dots.forEach(function (dot, i) {
        var active = i === index;
        dot.classList.toggle('bg-[#E31E24]', active);
        dot.classList.toggle('w-8', active);
        dot.classList.toggle('bg-white/40', !active);
        dot.classList.toggle('w-2', !active);
      });
      current = index;
    }

    function next() {
      show((current + 1) % slides.length);
    }

    function restart() {
      if (timer) clearInterval(timer);
      timer = setInterval(next, AUTOPLAY_MS);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        restart();
      });
    });

    show(0);
    restart();
  }

  /* ---------------- Mega menu (desktop hover) ---------------- */
  function initMegaMenu() {
    var items = Array.prototype.slice.call(document.querySelectorAll('[data-nav-item]'));
    if (!items.length) return;
    var header = document.querySelector('[data-auzone-header]');
    var GUTTER = 16;

    /* Each 650px panel is centred under its own nav item (left-1/2 with
       -translate-x-1/2). For the leftmost items that centre point sits so far left
       that the panel runs off the page and underneath the brand column, and for the
       rightmost item it runs off the right edge. Nudge the panel back inside the
       content column, never letting it begin before the logo ends.

       The correction is published as the --auzone-panel-shift custom property, which
       assets/auzone-base.css folds into the panel's transform. Margin and left cannot
       be used here: this store's CSS forces margin to 0 and Tailwind pins left:50%,
       both with !important, so neither responds to an inline style. Custom properties
       are not affected by that, and keeping the open/close translate in the same
       transform means the animation still runs.
       Recalculated on every open, so it follows viewport changes. */
    function position(panel) {
      panel.style.setProperty('--auzone-panel-shift', '0px');
      if (!header) return;
      var container = header.querySelector('.max-w-7xl');
      if (!container) return;
      var box = container.getBoundingClientRect();
      var min = box.left + GUTTER;
      var brand = header.querySelector('.auzone-brand');
      if (brand) {
        var b = brand.getBoundingClientRect();
        if (b.width) min = Math.max(min, b.right + GUTTER);
      }
      var max = box.right - GUTTER;
      var rect = panel.getBoundingClientRect();
      var shift = 0;
      if (rect.left < min) shift = min - rect.left;
      else if (rect.right > max) shift = max - rect.right;
      panel.style.setProperty('--auzone-panel-shift', Math.round(shift) + 'px');
    }

    items.forEach(function (item) {
      var panel = item.querySelector('[data-nav-panel]');
      if (!panel) return;
      var open = function () {
        position(panel);
        panel.classList.remove('opacity-0', 'invisible', 'translate-y-4');
        panel.classList.add('opacity-100', 'visible', 'translate-y-0');
      };
      var close = function () {
        panel.classList.add('opacity-0', 'invisible', 'translate-y-4');
        panel.classList.remove('opacity-100', 'visible', 'translate-y-0');
      };
      item.addEventListener('mouseenter', open);
      item.addEventListener('mouseleave', close);
      item.addEventListener('focusin', open);
      item.addEventListener('focusout', function (e) {
        if (!item.contains(e.relatedTarget)) close();
      });
    });

    window.addEventListener('resize', function () {
      items.forEach(function (item) {
        var panel = item.querySelector('[data-nav-panel]');
        if (panel) panel.style.setProperty('--auzone-panel-shift', '0px');
      });
    });
  }

  /* ---------------- Sticky header shadow ---------------- */
  function initHeaderShadow() {
    var header = document.querySelector('[data-auzone-header]');
    if (!header) return;
    var onScroll = function () {
      header.classList.toggle('shadow-md', window.scrollY > 8);
    };
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------------- Mobile menu drawer ---------------- */
  function initMobileMenu() {
    var btn = document.querySelector('[data-mobile-menu-btn]');
    var drawer = document.querySelector('[data-mobile-menu-drawer]');
    var backdrop = document.querySelector('[data-mobile-menu-backdrop]');
    var closeBtn = document.querySelector('[data-mobile-menu-close]');
    if (!btn || !drawer) return;
    var open = function () {
      drawer.classList.remove('translate-x-full');
      if (backdrop) backdrop.classList.remove('hidden');
      document.body.classList.add('overflow-hidden');
    };
    var close = function () {
      drawer.classList.add('translate-x-full');
      if (backdrop) backdrop.classList.add('hidden');
      document.body.classList.remove('overflow-hidden');
    };
    btn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (backdrop) backdrop.addEventListener('click', close);

    var accordions = drawer.querySelectorAll('[data-mobile-accordion-trigger]');
    accordions.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var panel = trigger.nextElementSibling;
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!isOpen));
        if (panel) panel.classList.toggle('hidden', isOpen);
        var chevron = trigger.querySelector('[data-mobile-chevron]');
        if (chevron) chevron.classList.toggle('rotate-180', !isOpen);
      });
    });
  }

  /* ---------------- Search flyout ---------------- */
  function initSearch() {
    var btn = document.querySelector('[data-search-btn]');
    var panel = document.querySelector('[data-search-panel]');
    if (!btn || !panel) return;
    btn.addEventListener('click', function () {
      panel.classList.toggle('hidden');
      if (!panel.classList.contains('hidden')) {
        var input = panel.querySelector('input[type="search"]');
        if (input) input.focus();
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHero();
    initMegaMenu();
    initHeaderShadow();
    initMobileMenu();
    initSearch();
  });
})();
